/* Venegas: consultation preparation only. No message is sent by the storefront. */
class AVConsultation extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('change', () => this.updateFields());
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      const data = new FormData(this.form);
      const need = this.form.elements.need;
      const lines = [this.dataset.intro];
      if (this.dataset.product) lines.push('Producto: ' + this.dataset.product, this.dataset.url);
      if (need) lines.push('Necesito: ' + need.selectedOptions[0].textContent);
      for (const [key, label] of [['city','Ciudad'],['postcode','Código postal'],['brand','Marca'],['model','Modelo'],['year','Año'],['engine','Motor'],['application','Aplicación / negocio'],['detail','Detalle']]) {
        const value = String(data.get(key) || '').trim();
        if (value) lines.push(label + ': ' + value);
      }
      const phone = String(this.dataset.phone || '').replace(/\D/g, '');
      if (phone.length < 10) return;
      window.location.assign('https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.filter(Boolean).join('\n')));
    });
    this.updateFields();
  }
  updateFields() {
    const wholesale = this.form.elements.need?.value === 'wholesale';
    this.querySelectorAll('[data-for]').forEach(group => {
      const shown = group.dataset.for === (wholesale ? 'wholesale' : 'vehicle');
      group.hidden = !shown;
      group.querySelectorAll('input,textarea').forEach(input => { input.disabled = !shown; });
    });
  }
}
if (!customElements.get('av-consultation')) customElements.define('av-consultation', AVConsultation);
if (!customElements.get('av-intents')) customElements.define('av-intents', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.addEventListener('click', event => {
      const link = event.target.closest('a[data-need]');
      if (!link) return;
      const field = document.querySelector('#asesoria select[name="need"]');
      if (!field) return;
      field.value = link.dataset.need;
      field.dispatchEvent(new Event('change', {bubbles:true}));
    });
  }
});
